import React from "react";
import styles from "./AccountingGraph.module.css";
import NumberAndData from "../../components/NumberAndData/NumberAndData";
import { FiEdit2 } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi2";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";

const AccountingGraph = () => {
  const handleEditClick = () => {
    console.log("This Month clicked");
  };

  const topData = [
    {
      number: 78,
      label: "Billed Amount",
      backgroundVar: "rgba(from var(--Primary_Color) r g b / 0.25)",
    },
    {
      number: 56,
      label: "paid amount",
      backgroundVar: "rgba(from var(--Error_Color) r g b / 0.25)",
    },
    {
      number: 11,
      label: "Expenses",
      backgroundVar: "rgba(from var(--Success_Color) r g b / 0.25)",
    },
  ];

  const billed = topData[0].number;
  const paid = topData[1].number;
  const expenses = topData[2].number;

  const maxValue = Math.max(billed, paid, expenses, 1); // prevent divide by 0

  const barData = [
    {
      height: (paid / maxValue) * 100,
      label: `INR ${paid}`,
      color: "var(--Success_Color)",
      bgColor: "rgba(60, 216, 85, 0.2)",
    },
    {
      height: (expenses / maxValue) * 100,
      label: `INR ${expenses}`,
      color: "rgba(138, 150, 255, 1)", // Adjusted for visibility
      bgColor: "rgba(138, 150, 255, 0.2)",
    },
  ];
  

  const legends = [
    {
      label: "Total Billed Amount",
      color: "rgba(60, 216, 85, 0.2)",
      textColor: "gray",
    },
    {
      label: "Total Collected Amount",
      color: "var(--Success_Color)",
      textColor: "green",
    },
    {
      label: "Expenses Amount",
      color: "rgba(from var(--Primary_Color)r g b / 0.7)",
      textColor: "rgba(from var(--Primary_Color)r g b / 0.7)",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<HiOutlineDocumentText />}
          heading="Enquires & Admissions"
        />
        <div className={styles.editWrapper} onClick={handleEditClick}>
          <FiEdit2 size={16} />
          <span>This Month</span>
        </div>
      </div>

      {/* 🧾 Top Indicators */}
      <div className={styles.topIndicators}>
        {topData.map((item, i) => (
          <NumberAndData key={i} {...item} />
        ))}
      </div>

      {/* 📊 Graph Section */}
      <div className={styles.graph}>
        {barData.map((bar, i) => (
          <div className={styles.barContainer} key={i}>
            <div className={styles.totalLabel}>INR 0</div>
            <div className={styles.barWrapper}>
              <div
                className={styles.totalBar}
                style={{ backgroundColor: bar.bgColor }}
              >
                <div
                  className={styles.installedBar}
                  style={{
                    height: `${bar.height}%`,
                    backgroundColor: bar.color,
                    color: bar.color === "white" ? "white" : "white",
                  }}
                >
                  {bar.label}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 🔘 Legend */}
      <div className={styles.legend}>
        {legends.map((item, i) => (
          <div className={styles.dotRow} key={i}>
            <span
              className={styles.dot}
              style={{ backgroundColor: item.color }}
            ></span>
            <span style={{ color: item.textColor }}>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountingGraph;
